<template>
  <aside
    :class="getClasses"
    class="sidebar"
  >
    <!-- List -->
    <nav class="sidebar__list">
      <!-- Home -->
      <router-link
        :to="{ name: 'home' }"
        exact
        active-class="sidebar__item--active"
        class="sidebar__item"
        @click.native="clickItem"
      >
        <span>{{ $t('header_1') }}</span>
      </router-link>

      <!-- About -->
      <router-link
        :to="{ name: 'about' }"
        active-class="sidebar__item--active"
        class="sidebar__item"
        @click.native="clickItem"
      >
        <span>{{ $t('header_2') }}</span>
      </router-link>

      <!-- Work -->
      <router-link
        :to="{ name: 'work_index' }"
        active-class="sidebar__item--active"
        class="sidebar__item"
        @click.native="clickItem"
      >
        <span>{{ $t('header_6') }}</span>
      </router-link>

      <!-- Careers -->
      <router-link
        :to="{ name: 'careers_index' }"
        active-class="sidebar__item--active"
        class="sidebar__item"
        @click.native="clickItem"
      >
        <span>{{ $t('header_9') }}</span>
      </router-link>

      <!-- Blog -->
      <router-link
        :to="{ name: 'blog_index' }"
        active-class="sidebar__item--active"
        class="sidebar__item"
        @click.native="clickItem"
      >
        <span>{{ $t('header_7') }}</span>
      </router-link>

      <!-- Contact -->
      <router-link
        :to="{ name: 'contact' }"
        active-class="sidebar__item--active"
        class="sidebar__item"
        @click.native="clickItem"
      >
        <span>{{ $t('header_3') }}</span>
      </router-link>
    </nav>

    <!-- Footer -->
    <nav class="sidebar__footer">
      <a
        href="https://twitter.com/blissapps"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="icon-twitter" />
      </a>

      <a
        href="https://www.instagram.com/blissapps/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="icon-instagram" />
      </a>

      <a
        href="https://www.behance.net/blissapps"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="icon-behance" />
      </a>

      <a
        href="https://www.linkedin.com/company/bliss-applications"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="icon-linkedin" />
      </a>

      <a
        href="https://www.facebook.com/blissapps/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="icon-facebook" />
      </a>

      <a
        href="https://dribbble.com/blissapps"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="icon-dribbble" />
      </a>
    </nav>
  </aside>
</template>

<script>
export default {
  name: 'Sidebar',

  props: {
    expand: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    getClasses() {
      if (this.expand) {
        return 'sidebar--expand';
      }

      return '';
    }
  },

  methods: {
    clickItem() {
      const body = document.getElementsByTagName('html')[0];
      body.style.overflow = 'auto';
      setTimeout(() => {
        this.$emit('click-item');
      }, 200);
    }
  }
};
</script>

<style lang="scss" src="../../assets/components/sidebar/sidebar-view.scss"></style>



// WEBPACK FOOTER //
// sidebar-view.vue